import { RoutalPalette } from '@nx-smartmonkey/ui';

export const ItemsSeparator = () => {
  return (
    <div style={{ height: `4px`, width: `4px`, backgroundColor: RoutalPalette.secondary20n, borderRadius: `50%` }} />
  );
};
